﻿import { Output } from "@models/configurators/outputs/output";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IFileOutput } from "@models/entity-models";
import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@Kbo(CToken.FileOutput)
export class FileOutput extends Output implements IFileOutput {
    constructor(kom: KbObjectManager, args?: IFileOutput) {
        super(kom, args);
        if (!args) {
            this.postToCloud = true;
        }
    }
    public templatePath: string;
    public targetDirectory: string;
    public targetFilename: string;
    public postToCloud: boolean;

}
